// extracted by mini-css-extract-plugin
module.exports = {"logo__symbol":"logo-module--logo__symbol--JgfyD","logo__text":"logo-module--logo__text--2xRVm"};